import LogRoutineTypes from 'store/actionTypes/logRoutine'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: {},
  codeRoutines: [],
  modules: []
}

const logRoutine = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case LogRoutineTypes.GET_LOG_ROUTINES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case LogRoutineTypes.GET_CODE_ROUTINES_SUCCESS:
      return { ...state, codeRoutines: payload?.items }
    case LogRoutineTypes.UPDATE_FILTER_LOG_ROUTINE_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default logRoutine
